import { useState } from "react";
import type { FormEvent } from "react";
import { useAuth } from "../lib/auth.js";
import { Button, ErrorNote, Field, Input } from "../ui/kit.js";

/**
 * Email + password. The technician's phone + PIN login lives in the field app and does not
 * belong here — /auth/office/login refuses a technician outright (routes/auth.ts), so an
 * office console that offered a PIN field would be offering a door that is bricked shut.
 */
export function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center p-8">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-lg border border-line bg-surface p-6"
      >
        <p className="text-2xl font-bold text-ink">فني</p>
        <p className="mt-1 mb-6 text-sm text-ink-soft">لوحة الإدارة — تسجيل دخول المكتب</p>

        {error ? <ErrorNote error={error} className="mb-4" /> : null}

        <Field label="البريد الإلكتروني" className="mb-3">
          <Input
            type="email"
            required
            dir="ltr"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>

        <Field label="كلمة المرور" className="mb-5">
          <Input
            type="password"
            required
            dir="ltr"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>

        <Button type="submit" variant="primary" className="w-full" disabled={busy}>
          {busy ? "جارٍ الدخول…" : "دخول"}
        </Button>
      </form>
    </div>
  );
}
